// extracted by mini-css-extract-plugin
export var blogForm = "blog-subscription-form-module--blogForm--42983";
export var col = "blog-subscription-form-module--col--a246a";
export var defaultOption = "blog-subscription-form-module--defaultOption--4e5ca";
export var dynamicOption = "blog-subscription-form-module--dynamicOption--a3587";
export var formHeader = "blog-subscription-form-module--formHeader--a8209";
export var hintText = "blog-subscription-form-module--hintText--bcff9";
export var honeyPotInputField = "blog-subscription-form-module--honeyPotInputField--f4dd9";